<template>
    <div class="TQ_centerAbsolute">

        <div class="TQ_maxWidth_350px    TQ_center">

            <div class="TQ_bg_white TQ_margin_8px TQ_padding_16px TQ_borderRadius">
                <div>
                    <si_-logo width="80px"></si_-logo>
                    <div>
                        <div class="TQ_text_24px">טרוול קווסט</div>
                        <div class="TQ_text_20px">פלטפורמה ליצירה ושיתוף של משחקי רחוב.</div>
                    </div>
                </div>

                <hr>

                <div class="TQ_center TQ_text_24px TQ_align_initial TQ_padding_8px">
                    <div class="lc_btn1 TQ_padding_12px TQ_margin_8px_0 TQ_box_shadow TQ_borderRadius">
                        <tq-image :src="ass_img_puzzle2_w" class="TQ_width_32px TQ_verticalAlignMiddle"/>
                        <div class="TQ_padding_8px TQ_inline TQ_verticalAlignMiddle"></div>
                        <div class="TQ_inline TQ_verticalAlignMiddle">כנס לקווסט</div>
                    </div>

                    <div class="lc_btn2 TQ_padding_12px TQ_margin_8px_0 TQ_box_shadow TQ_borderRadius ">
                        <tq-image :src="ass_img_search_w" class="TQ_width_32px TQ_verticalAlignMiddle"/>
                        <div class="TQ_padding_8px TQ_inline TQ_verticalAlignMiddle"></div>
                        <div class="TQ_inline TQ_verticalAlignMiddle">חפש קווסט חדש</div>
                    </div>

                    <div class="lc_btn3 TQ_padding_12px TQ_margin_8px_0 TQ_box_shadow TQ_borderRadius">
                        <tq-image :src="ass_img_edit_w" class="TQ_width_32px TQ_verticalAlignMiddle"/>
                        <div class="TQ_padding_8px TQ_inline TQ_verticalAlignMiddle"></div>
                        <div class="TQ_inline TQ_verticalAlignMiddle">צור קווסט</div>
                    </div>
                </div>

            </div>


        </div>


    </div>
</template>

<script>
    import TqImage from "../../components/basic/TqImage";
    import Si_Logo from "../../components/a_smartIcons/si_Logo";
    import {ass_img_edit_w, ass_img_puzzle2_w, ass_img_search_w} from "../../assets/scripts/Ass_Files";
    export default {
        name: "v_FirstPage",
        components: {Si_Logo, TqImage},
        data(){
            return {
                ass_img_puzzle2_w : ass_img_puzzle2_w,
                ass_img_search_w : ass_img_search_w,
                ass_img_edit_w : ass_img_edit_w,
            }
        }
    }
</script>

<style scoped lang="scss">
    .lc_btn1{
        /*border: 2px solid var(--color-green);*/
        background: var(--color-green);
        color: white;
    }

    .lc_btn2{
        /*border: 2px solid var(--color-blue);*/
        background: var(--color-blue);
        color: white;
    }

    .lc_btn3{
        /*border: 2px solid black;*/
        background: #501078;
        background: var(--color-purple);
        color: white;
    }
</style>